<div class="fields-filter-container">
  <mydocma-app-pane-header
    (closeClick)="onCloseClick()"
    class="fields-filter-header"
    text="{{ 'MM.fields.leftPane.title' | translate }}"
    [closeVisible]="showCloseInHeader"
    [doneVisible]="false"
    [iconName]="'_filter-default'">
  </mydocma-app-pane-header>
  
  <div class="fields-filter-form">
    <mydocma-dynamic-form
      *ngIf="formConfig"
      [formConfig]="formConfig"
      (ready)="onFormReady($event)">
    </mydocma-dynamic-form>
    
    <mat-form-field style="display: none">
      <mat-date-range-input
        [rangePicker]="picker"
      >
        <input
          matStartDate 
          placeholder="Start date"
          [value]="filterHandlerService?.startDate"
          (dateChange)="onDatePickerChange($event, 'start')">
        <input
          [value]="filterHandlerService?.endDate"
          matEndDate 
          placeholder="End date"
          (dateChange)="onDatePickerChange($event, 'end')"
        >
      </mat-date-range-input>
      <mat-date-range-picker 
        panelClass="fields-filter-range-date-picker" 
        #picker>
      </mat-date-range-picker>
    </mat-form-field>
  </div>
  
  <div class="mobile-pane-footer" *ngIf="!showCloseInHeader">
    <div style="margin-right: 10px">
      <button mat-stroked-button (click)="onCloseClick()" class="mydocma-btn-primary">
        {{ 'MM.general.button.ok' | translate }}
      </button>
    </div>
  </div>
</div>